import { ScannedCategory } from '@components'

import { AttachmentFile } from '@billy/design-system'

import { getParsedDataFromAttachment } from './getParsedDataFromAttachment'

export const getScannedCategoryResultFromAttachmentsFiles = (
  attachmentsFiles?: AttachmentFile[],
): ScannedCategory[] => {
  // more than one file is not yet supported by ML Category Search endpoint
  if (!attachmentsFiles || !attachmentsFiles.length || attachmentsFiles.length > 1) {
    return []
  }

  try {
    const parsedData = getParsedDataFromAttachment(attachmentsFiles[0])

    if (!parsedData?.tagScores) {
      return []
    }

    return parsedData.tagScores.map(
      ({ tagId, tagName, score }): ScannedCategory => ({
        id: parseInt(tagId, 10),
        name: tagName,
        score,
      }),
    )
  } catch {
    return []
  }
}
